import React, { useState } from 'react';

import { toolbarControlStyle } from './toolbar-styles';

export type ToolbarButtonProps = {
	title: string;
	onClick: () => void;
	children: React.ReactNode;
	/** Short caption shown beside the icon; omit for the dense icon-only form */
	label?: string;
	isActive?: boolean;
	disabled?: boolean;
	tone?: 'default' | 'danger';
};

/** The one button shape every annotation-toolbar control uses, so hover/active/disabled read identically everywhere */
export const ToolbarButton = (props: ToolbarButtonProps): React.ReactElement => {
	const { title, onClick, children, label, isActive = false, disabled = false, tone = 'default' } = props;
	const [isHovered, setIsHovered] = useState(false);

	return (
		<button
			type="button"
			title={title}
			aria-label={title}
			aria-pressed={isActive}
			disabled={disabled}
			onClick={onClick}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			style={toolbarControlStyle({ isActive, isHovered, disabled, tone, hasLabel: Boolean(label) })}
		>
			{children}
			{label ? <span style={{ userSelect: 'none' }}>{label}</span> : null}
		</button>
	);
};
